import { Input } from '@/components/ui/input';
import { Icon } from '@/lib/icons';
import type { translations } from '@/translations/translations';
import type { ThemeQuestionFormValue } from './theme-question-editor.types';

interface Props {
  copy: typeof translations.fr.admin.excelFiles.themes.questions;
  value: ThemeQuestionFormValue;
  isAdding: boolean;
  onChange: (value: ThemeQuestionFormValue) => void;
  onAdd: () => void;
}

export function ThemeQuestionEditorForm({ copy, value, isAdding, onChange, onAdd }: Props) {
  const update = (field: keyof ThemeQuestionFormValue, text: string) => {
    onChange({ ...value, [field]: text });
  };
  const isValid = value.questionText.trim().length > 0 && value.language.trim().length > 0;

  return (
    <form onSubmit={(event) => { event.preventDefault(); onAdd(); }}
      className="rounded-xl border border-border/50 bg-muted/20 p-4">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">{copy.addTitle}</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <Input value={value.questionText} onChange={(event) => update('questionText', event.target.value)}
          placeholder={copy.questionText} aria-label={copy.questionText} maxLength={2000} className="border-border/50 bg-background sm:col-span-2" />
        <Input value={value.language} onChange={(event) => update('language', event.target.value)}
          placeholder={copy.language} aria-label={copy.language} maxLength={40} className="border-border/50 bg-background" />
        <Input value={value.domain} onChange={(event) => update('domain', event.target.value)}
          placeholder={copy.domain} aria-label={copy.domain} maxLength={255} className="border-border/50 bg-background" />
        <Input value={value.source} onChange={(event) => update('source', event.target.value)}
          placeholder={copy.source} aria-label={copy.source} maxLength={255} className="border-border/50 bg-background sm:col-span-2" />
      </div>
      <div className="mt-3 flex justify-end">
        <button type="submit" disabled={!isValid || isAdding}
          className="inline-flex h-9 items-center gap-2 rounded-full bg-primary px-5 text-xs font-semibold text-primary-foreground disabled:opacity-40">
          <Icon name={isAdding ? 'loader2' : 'plus'} className="h-4 w-4" />
          {isAdding ? copy.adding : copy.add}
        </button>
      </div>
    </form>
  );
}
